module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/staff-label-da2663788b60e5e6ca88d524decf6a39.svg";